import script from "./Player.vue?vue&type=script&lang=ts&setup=true"
export * from "./Player.vue?vue&type=script&lang=ts&setup=true"

import "./Player.vue?vue&type=style&index=0&id=040800d8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040800d8"]])

export default __exports__